import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { SearchSourcePreference } from '../schema/SearchSourcePreference';

/**
 * Returns the search source to be used based on user's SessionSettings
 */
export const getSearchSourceFromConfig = () => {
    const isSubstrateSearchEnabled = getUserConfiguration().SessionSettings
        .IsSubstrateSearchServiceAvailable;

    return isSubstrateSearchEnabled
        ? SearchSourcePreference.SubstrateSearch
        : SearchSourcePreference.LegacySearch;
};
